import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rr0113',
    ecrans: ['00-2'],
    params: ['stamnetab', 'specleintref']
});
